<script setup lang="ts">
/**
 * The toast host a modal carries while it is open (NxModal only — not exported). It renders
 * where and how the page's host does; see `useNxToastHost`.
 */
import { provide } from 'vue';
import NxToastHost from './NxToastHost.vue';
import { nxToastHostInheritKey } from './useNxToasts';

provide(nxToastHostInheritKey, true);
</script>

<template>
  <NxToastHost />
</template>
